import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Card, Row, Typography, Slider, Input, Button, Col, Skeleton, Form, Select, message } from "antd";
import axiosInstance from "../../../axiosInterceptor";
import { SketchPicker } from "react-color";

import { UploadOutlined } from '@ant-design/icons';
import { useDropzone } from 'react-dropzone';
import imageCompression from 'browser-image-compression';

const HomeTextos = ({ recarregarDados }) => {
  const accessToken = window.localStorage.getItem("accessToken");

  const [loading, setLoading] = useState(false);
  const [loja, setLoja] = useState(null);
  const idUser = window.localStorage.getItem("idUser");
  const [idLoja, setIDLoja] = useState(null);
  const [reload, setReload] = useState(true);

  const [firstColor, setFirstColor] = useState("#8fb1dd");
  const [secondColor, setSecondColor] = useState("#fff");
  const [gradientDirection, setGradientDirection] = useState(45);

  const [firstSectionTitle, setFirstSectionTitle] = useState("");
  const [firstSectionText, setFirstSectionText] = useState("");
  const [firstSectionYoutubeLink, setFirstSectionYoutubeLink] = useState("");
  const [firstSectionHasImageOrVideo, setFirstSectionHasImageOrVideo] = useState("video");
  const [firstSectionImageSrc, setFirstSectionImageSrc] = useState(null);
  const [firstSectionButtonHref, setFirstSectionButtonHref] = useState("");

  const [firstSectionButtonTxt, setFirstSectionButtonTxt] = useState("");


  const options = [
    { value: 'image', label: 'Imagem' },
    { value: 'video', label: 'Vídeo' }
  ];

  const handleSliderChange = (value) => {
    setGradientDirection(value);
  };

  const handleSave = () => {
    const jsonData = {
      FirstSectionTitle: firstSectionTitle,
      FirstSectionText: firstSectionText,
      FirstSectionYoutubeLink: firstSectionYoutubeLink,
      FirstSectionHasImageOrVideo: firstSectionHasImageOrVideo,
      FirstSectionImageSrc: firstSectionImageSrc,
      FirstSectionButtonHref: firstSectionButtonHref,
      FirstSectionButtonTxt: firstSectionButtonTxt
    };
    console.log(JSON.stringify(jsonData));
    let body = JSON.stringify(jsonData);
    try {
      setLoading(true);
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

      axiosInstance.put(
        `https://api.pedtech.com.br/v1/pedtech/primeiraSessaoTexto/`+idLoja, body,
        options
      ).then((resp) => {
        if (resp.status == 200) {
          message.success('Conteudo salvo!');
        }
        setLoading(false);
      });

    } catch (error) {
      console.error('Erro ao chamar a API:', error.status);
      if (error.status === 404) {
        message.error('Erro ao gravar!');
      }
      setLoading(false);
    }
    
  };



  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: async (acceptedFiles) => {
      const compressedFile = await handleImageCompression(acceptedFiles[0]);
      const base64 = await convertToBase64(compressedFile);
      localStorage.setItem("firstSectionImageSrc", base64);
      setFirstSectionImageSrc(base64); // Armazena a string base64 diretamente
      message.success('Imagem carregada e convertida com sucesso!');
    },
  });

  const handleImageCompression = async (file) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
      fileType: 'image/webp',
    };
    
    try {
      const compressedFile = await imageCompression(file, options);
      return compressedFile;
    } catch (error) {
      console.error('Erro ao comprimir a imagem:', error);
      message.error('Erro ao comprimir a imagem!');
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  useEffect(() => {
    if (idUser) {
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };
      axiosInstance.get(
        `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`,
        options
      ).then((resp) => {
        setIDLoja(resp.data.id);
        setLoja(resp.data);
      });
    }
  }, [idUser]);

  const loadDados = () => {

    setLoading(true);
    const options = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    axiosInstance.get(
      `https://api.pedtech.com.br/v1/pedtech/getByEmpresa/`+idLoja,
      options
    ).then((resp) => {
      const data = resp.data.FirstSectionContents;
      setFirstSectionTitle(data.FirstSectionTitle);
      setFirstSectionText(data.FirstSectionText);
      setFirstSectionYoutubeLink(data.FirstSectionYoutubeLink);
      setFirstSectionHasImageOrVideo(data.FirstSectionHasImageOrVideo);
      setFirstSectionImageSrc(data.FirstSectionImageSrc);
      setFirstSectionButtonHref(data.FirstSectionButtonHref);
      setFirstSectionButtonTxt(data.FirstSectionButtonTxt)

      console.log(data);
      setLoading(false);
    }).catch((error) => {
      setLoading(false);
      if (error.response.status === 404) {
        console.error("Data not found");
      }
    });
  }

  useEffect(() => {
    setLoading(true);

    if (idUser && idLoja) {
      loadDados();
    }
  }, [idUser, accessToken, reload, idLoja]);


  return (
    <Container>
      <Card style={{ width: "80%", marginTop: "140px", marginBottom: "110px" }}>
        <h1
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          Conteúdo Primeira Seção
        </h1>

        <Row>
          <Col xs={24} lg={24}>
            {loading ? (
              <Skeleton active />
            ) : (
              <FormContainer>
                <Form
                  name="FirstSectionForm"
                  onFinish={handleSave}
                  layout="vertical"
                  style={{ width: "100%" }}
                >
                  <Form.Item
                      label={
                        <>
                          Título da Primeira Seção &nbsp;<b>(Para não exibir a seção basta apagar o texto e salvar sem título)</b>
                        </>
                      }
                    name="FirstSectionTitle"
                    initialValue={firstSectionTitle}
                    rules={[
                      { required: true, message: "Por favor, insira o título!" },
                    ]}
                  >
                    <Input
                      value={firstSectionTitle}
                      onChange={(e) => setFirstSectionTitle(e.target.value)}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Texto da Primeira Seção"
                    name="FirstSectionText"
                    initialValue={firstSectionText}
                    rules={[
                      { required: true, message: "Por favor, insira o texto!" },
                    ]}
                  >
                    <Input.TextArea
                      value={firstSectionText}
                      onChange={(e) => setFirstSectionText(e.target.value)}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Link do Youtube"
                    name="FirstSectionYoutubeLink"
                    initialValue={firstSectionYoutubeLink}
                  >
                    <Input
                      value={firstSectionYoutubeLink}
                      onChange={(e) => setFirstSectionYoutubeLink(e.target.value)}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Imagem ou Vídeo"
                    name="FirstSectionHasImageOrVideo"
                    initialValue={firstSectionHasImageOrVideo}
                  >
                    <Select
                      value={firstSectionHasImageOrVideo}
                      onChange={(value) => setFirstSectionHasImageOrVideo(value)}
                      options={options}
                    />
                  </Form.Item>

                  
                  <Form.Item
                    label="Fonte da Imagem (Recomendado: 600x600)"
                    name="FirstSectionImageSrc"
                  >
                    <div {...getRootProps()} className="dropzone">
                      <input {...getInputProps()} />
                      <Button icon={<UploadOutlined />}>Carregar Imagem</Button>
                    </div>
                    {firstSectionImageSrc && (
                      <img src={firstSectionImageSrc} alt="Preview" style={{ width: '30%', marginTop: '10px' }} />
                    )}
                  </Form.Item>
                  

                  <Form.Item
                    label="Texto do Botão (deixe vazio se não desejar o botão)"
                    name="FirstSectionButtonTxt"
                    initialValue={firstSectionButtonTxt}
                  >
                    <Input
                      value={firstSectionButtonTxt}
                      onChange={(e) => setFirstSectionButtonTxt(e.target.value)}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Link do Botão"
                    name="FirstSectionButtonHref"
                    initialValue={firstSectionButtonHref}
                  >
                    <Input
                      value={firstSectionButtonHref}
                      onChange={(e) => setFirstSectionButtonHref(e.target.value)}
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ width: "100%" }}
                    >
                      SALVAR
                    </Button>
                  </Form.Item>
                </Form>
              </FormContainer>
            )}
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default HomeTextos;
